import React from "react";
import { TouchableOpacity } from "react-native";
import Svg, { Path, G } from "react-native-svg";
import AppTheme from "../../../AppTheme";
import MoodColors from "../MoodColors";

export default function VeryGood(props) {
  const color = props.color || MoodColors.VeryGood;
  const opacity = props.selected ? 1 : AppTheme.moodOpacity;
  const width = props.width || 36;
  const height = props.height || 36;

  return (
    <TouchableOpacity style={props.styles} {...props}>
      <Svg
        width={width}
        height={height}
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <G opacity={opacity}>
          <Path
            d="M30.7278 30.7279C37.7573 23.6985 37.7573 12.3015 30.7278 5.27208C23.6984 -1.75736 12.3014 -1.75736 5.27199 5.27208C-1.75745 12.3015 -1.75745 23.6985 5.27199 30.7279C12.3014 37.7574 23.6984 37.7574 30.7278 30.7279Z"
            fill={color}
          />
          <Path
            d="M23.6528 25.2371C21.5445 25.8239 15.3656 25.7501 13.5078 25.101C13.3346 25.0403 13.1564 25.1512 13.194 25.3324C13.5198 26.9358 15.2848 29.3523 18.9598 29.3523C22.2844 29.3523 23.7863 26.4744 23.9796 25.4665C24.0268 25.232 23.8832 25.1728 23.6528 25.2371Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            d="M25.0452 19.2755C25.9565 19.2755 26.6952 18.5368 26.6952 17.6255C26.6952 16.7143 25.9565 15.9755 25.0452 15.9755C24.1339 15.9755 23.3952 16.7143 23.3952 17.6255C23.3952 18.5368 24.1339 19.2755 25.0452 19.2755Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M25.3726 17.4137C25.6063 17.4137 25.7958 17.2242 25.7958 16.9905C25.7958 16.7568 25.6063 16.5674 25.3726 16.5674C25.1389 16.5674 24.9495 16.7568 24.9495 16.9905C24.9495 17.2242 25.1389 17.4137 25.3726 17.4137Z"
            fill="white"
          />
          <Path
            d="M27.7811 11.7965C26.7506 10.7203 25.1748 10.4146 23.8717 11.038"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.868426"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M9.28912 12.3332C10.3408 10.9934 11.9426 10.6586 13.2648 11.5054"
            stroke={AppTheme.almostBlack}
            strokeWidth="0.990909"
            strokeMiterlimit="10"
            strokeLinecap="round"
          />
          <Path
            d="M11.8433 19.4342C12.7546 19.4342 13.4933 18.6954 13.4933 17.7842C13.4933 16.8729 12.7546 16.1342 11.8433 16.1342C10.932 16.1342 10.1933 16.8729 10.1933 17.7842C10.1933 18.6954 10.932 19.4342 11.8433 19.4342Z"
            fill={AppTheme.almostBlack}
          />
          <Path
            opacity="0.61"
            d="M12.2423 17.5723C12.476 17.5723 12.6655 17.3828 12.6655 17.1491C12.6655 16.9154 12.476 16.726 12.2423 16.726C12.0086 16.726 11.8192 16.9154 11.8192 17.1491C11.8192 17.3828 12.0086 17.5723 12.2423 17.5723Z"
            fill="white"
          />
        </G>
      </Svg>
    </TouchableOpacity>
  );
}
